<template>
  <div>
    <h3 class="h3 mt0">My Location(s)</h3>
    <p class="mb2">Here you can put locations where you practice so we can help identify you easier.</p>
    <transition
      name="fade"
      mode="out-in"
    >
      <module-form
        v-if="editDetails || false"
        :fields="fields"
        form-id="dentist-location"

        button-size="m"
        button="primary"
        :submit="submitLabel"

        :action="action"
        :success="success"
        :fail="fail"
      >
        <module-button
          slot="submit-extras"
          button="tertiary"
          size="m"
          type="button"
          @click.native="editLocation()"
          label="Cancel"
        />
        <div slot="submit-extras" class="location__remove mt2">
          <module-link v-if="!isNewLocation" type="button" class="location__link small fw-bold" @click.native="removeLocation()">Remove Location</module-link>
        </div>
      </module-form>
      <div
        v-if="!editDetails"
        class="locations"
      >
        <p class="mt mb2" v-if="!hasLocations">You have not added your location yet, click below to add your address</p>
        <div
          v-for="(location, index) in user.locations"
          :key="index"

          class="locations__location"
        >
          <div class="location__title">
            <h4 class="h4 mt0 mb0">{{ location.name }}</h4>
            <module-link class="location__link small fw-bold" @click.native="editLocation(location.id)">Edit this location</module-link>
          </div>
          <module-detail-list
            :items="{
              'Address Line One': location.address_1,
              'Address Line Two': location.address_2,
              'City': location.city,
              'State': location.state,
              'ZIP': location.zipcode,
            }"
          />
        </div>
        <module-button
          size="m"
          @click.native="editLocation()"
          level="secondary"
          button="primary"
          label="Add Location"
        />
      </div>
    </transition>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Services
import { arrayLoop } from 'services/array';

// Models
import { dentistLocation } from 'models/dashboard/userDetails.js';

// Modules
import ModuleButton from 'modules/Button';
import ModuleDetailList from 'modules/DetailList';
import ModuleForm from 'modules/Form';
import ModuleLink from 'modules/Link';

export default {
  name: `ui-dashboard-dentist-locations`,

  // Components
  components: {
    ModuleButton,
    ModuleDetailList,
    ModuleForm,
    ModuleLink,
  },

  // Data
  data () {
    return {
      fields: dentistLocation,
      editDetails: false,
      locationId: ``,
    };
  },

  computed: {
    ...mapGetters(`auth`, [
      `user`,
      `showTour`,
    ]),
    ...mapGetters(`forms`, [
      `getModel`,
      `getStatus`,
    ]),
    hasLocations() {
      return this.user.locationsCount > 0;
    },
    isNewLocation() {
      return this.locationId.length < 1;
    },
    submitLabel() {
      return this.isNewLocation ? `Save` : `Save Changes`;
    },
    model() {
      return this.getModel(`dentist-location`);
    },
  },

  // Methods
  methods: {
    ...mapActions(`auth`, [
      `requestUpdateDentistLocation`,
      `requestRemoveDentistLocation`,
      `deactivateTour`,
    ]),
    editLocation(id) {
      if(this.editDetails) {
        this.editDetails = false;
        this.locationId = ``;
        return false;
      }

      this.locationId = id || ``;

      arrayLoop(this.fields, (key) => {
        const location = this.user.locations[id] || {};
        if (this.fields[key]) {
          const value = id ? location[key] : null;
          this.fields[key].value = value || ``;
        }
      });

      this.$nextTick(() => this.editDetails = true);
    },

    removeLocation() {
      this.requestRemoveDentistLocation(this.locationId)
        .then(() => {
          this.editLocation();
        });
    },

    action() {
      const model = {
        ...this.model,
        id: this.locationId,
      };
      return this.requestUpdateDentistLocation(model);
    },

    success() {
      if(this.showTour === `reviewer`) {
        this.$router.push({
          name: `dashboard-reviewer-application`,
        });
      } else {
        if(this.showTour === `dentist`) {
          this.deactivateTour();
        }

        setTimeout(() => {
          this.editLocation();
        }, 1000);
      }
    },

    fail(fail) {
      console.warn(fail);
    },
  },

};
</script>



// WEBPACK FOOTER //
// Locations.vue?4efb0476